<script lang="ts">import { getPromotions, sortPromotions } from "./data";
import { stateFeatureSet, stateTheme } from "@infinitro/config";
import { Container } from "@infinitro/container";
import { locale, loggedIn, refreshVipState, refreshRaces, stateDepositBonusOffers, stateRaces } from "@infinitro/global";
import { onMount } from "svelte";
import { derived } from "svelte/store";
import AllPromotions from "./parts/all-promotions.svelte";
import { mapRacesToPromotions } from "./state";
let promotionsBatchSize = 6;
let promotionsLoaded = promotionsBatchSize;
const EXPIRED_RACES_LIMIT = 3;
function parseNaiveDateAsUtc(dateValue) {
	if (/Z|[+-]\d{2}:\d{2}$/.test(dateValue)) {
		return new Date(dateValue).getTime();
	}
	return new Date(`${dateValue}Z`).getTime();
}
function getLatestExpiredRaces(races) {
	const nowMs = Date.now();
	return [...races].filter((race) => parseNaiveDateAsUtc(race.endDate) < nowMs).sort((a, b) => parseNaiveDateAsUtc(b.endDate) - parseNaiveDateAsUtc(a.endDate)).slice(0, EXPIRED_RACES_LIMIT);
}
const promotions = derived([
	stateFeatureSet,
	stateTheme,
	stateDepositBonusOffers,
	stateRaces,
	locale,
	loggedIn
], ([$featureSet, $theme, $depositOffers, $races, $locale, $loggedIn]) => {
	const basePromos = getPromotions($featureSet, $theme, $locale, $loggedIn);
	const latestExpiredRaces = getLatestExpiredRaces($races ?? []);
	const racePromos = mapRacesToPromotions(latestExpiredRaces, false);
	const all = sortPromotions([...basePromos, ...racePromos]);
	return all;
});
function loadMorePromotions() {
	promotionsLoaded += promotionsBatchSize;
}
let observer;
onMount(() => {
	refreshRaces();
	refreshVipState();
	observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				loadMorePromotions();
			}
		});
	});
	const sentinel = document.querySelector("#sentinel");
	if (sentinel) {
		observer.observe(sentinel);
	}
});
</script>

<Container>
	<AllPromotions {promotions} />
	<slot />
</Container>
